import styled from "styled-components";
import { COLORS } from "../../../../../../../../../styles/constants.style";

export const BillingTypeFieldInvoiceWrapper = styled.div`
  .dashed-line {
    margin: 24px 0px;
    border: 1px dashed ${COLORS.primary_light_blue4};
  }

  .MuiGrid2-root {
    padding-right: 0px;
  }

  .billing-instructions {
    padding-top: 8px;
  }
`;
